export const version = process.env.VERSION
export const name = process.env.APP_NAME || 'POSPORTAL'
export const locale = 'pt-BR'
export const permissions = {PERMISSIONS: {
    owner: '"owner"',
    public: '"public"',
    auth_logout: '"auth.logout"',
    auth_me: '"auth.me"',
    auth_profile_update: '"auth.profile.update"',
    auth_profile_avatar: '"auth.profile.avatar"',
    auth_password_update: '"auth.password.update"',
    auth_logs_accesses: '"auth.logs.accesses"',
    tenants_switch: '"tenants.switch"',
    tenants_invite: '"tenants.invite"',
    tenants_invites: '"tenants.invites"',
    tenants_index: '"tenants.index"',
    tenants_store: '"tenants.store"',
    tenants_show: '"tenants.show"',
    tenants_update: '"tenants.update"',
    tenants_destroy: '"tenants.destroy"',
    users_index: '"users.index"',
    users_store: '"users.store"',
    users_show: '"users.show"',
    users_update: '"users.update"',
    users_destroy: '"users.destroy"',
    users_attach_role: '"users.attach.role"',
    users_detach_role: '"users.detach.role"',
    accounts_switch: '"accounts.switch"',
    accounts_index: '"accounts.index"',
    accounts_store: '"accounts.store"',
    accounts_show: '"accounts.show"',
    accounts_update: '"accounts.update"',
    accounts_destroy: '"accounts.destroy"',
    roles_index: '"roles.index"',
    roles_store: '"roles.store"',
    roles_show: '"roles.show"',
    roles_update: '"roles.update"',
    roles_destroy: '"roles.destroy"',
    permissions_store: '"permissions.store"',
    permissions_index: '"permissions.index"',
    geo_cities_index: '"geo.cities.index"',
    geo_cities_show: '"geo.cities.show"',
    geo_find_address: '"geo.find.address"',
    geo_find_cep: '"geo.find.cep"',
    geo_countries_index: '"geo.countries.index"',
    geo_countries_show: '"geo.countries.show"',
    geo_states_index: '"geo.states.index"',
    geo_states_show: '"geo.states.show"'
  }}
export const userTokenStorageKey = 'iu'
export const userGSKStorageKey = 'gsk'
